<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row">

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div v-if="locationDropdown && locationDropdown.length">
          <SelectVue
              v-model="filters.locationId"
              :options="locationDropdown"
              :is-clear="true"
              placeholder="Standort"
          />
        </div>
      </div>
      <div class="col-lg-5 col-md-6 col-sm-12">
        <div v-if="coachDropdown && coachDropdown.length">
          <SelectVue
              v-model="filters.coachId"
              :options="coachDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.coach')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-12 col-12 order-last order-lg-0 text-center text-lg-left mb-3 mb-lg-0">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            :placeholder="$t('placeholder.start_date')"
            position="down"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            :placeholder="$t('placeholder.end_date')"
            position="down"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="coachBillingTypeDropdown && coachBillingTypeDropdown.length">
          <SelectVue
              @update:modelValue="onChangeBillingType"
              v-model="filters.billingType"
              :options="coachBillingTypeDropdown"
              :is-clear="false"/>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <BaseCheckbox
            v-model="filters.signed"
            :labelPosition="'right'"
            label="Unterschriftspflichtig"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  coachDropdown: {
    type: Array,
    required: true,
  },
  locationDropdown: {
    type: Array,
    required: true,
  },
  coachBillingTypeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const { filters }              = toRefs(props);
const coachDropdown            = toRefs(props)[ 'coachDropdown' ];
const locationDropdown         = toRefs(props)[ 'locationDropdown' ];
const coachBillingTypeDropdown = toRefs(props)[ 'coachBillingTypeDropdown' ];
const emit                     = defineEmits([ 'search', 'changeBillingType' ]);

function onSearch() {
  emit('search', filters.value);
}

function onChangeBillingType() {
  emit('changeBillingType', true);
}

</script>

<style scoped>
</style>
